import React, { createContext } from 'react';
import type { FC, ReactNode } from 'react';

import type { Panorama } from './createPanorama.js';

export const PanoramaContext = createContext<Panorama | undefined>(undefined);

interface PanoramaProviderProps {
  children: ReactNode;
  value: Panorama;
}

export const PanoramaProvider: FC<PanoramaProviderProps> = (props) => {
  const { value, children } = props;
  return (
    <PanoramaContext.Provider value={value}>
      {children}
    </PanoramaContext.Provider>
  );
};
